var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0A3957"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4.716L19.286 12L12 19.287L4.713 12zm.043.602L18.686 12l-6.643 6.604L5.315 12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.348 16.376l.987.965l.34-.373l-.626-.623l.953-.957l.94.987l-.606.593l.377.373l.92-.966l-1.63-1.69zm2.08-3.089l-.435.429l-.422-.429zm.221-5.208l-.992.975l.335.359l.657-.69l.33.33l-.611.649l.334.3l.601-.653l1.355 1.334l.635-.616l.99.951l.346-.335l-1.336-1.334l-.635.654zm-5.59 3l-.321.331l.927.98l1.375-1.362l-.337-.353l-1.038 1.007zm7.554.279l-.324-.329l-.981.924l1.332 1.403l.354-.336l-.986-1.059z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.886 11.094l.3.351l-.987.918l-1.304-1.412l.367-.346l1.001 1.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.896 12.452l.3.35l-.987.917l-1.57-1.665l.385-.348l1.23 1.308zM9.43 11.426l.337-.315l.945.961l-1.387 1.35l-.34-.35l1.026-1.019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.059 12.406l-.321.33l.927.98l1.687-1.65l-.337-.354l-1.35 1.297zm4.592-6.011l.36-.345l.362.345l-.361.345zm-5.62 5.607l.361-.345l.361.345l-.36.344zm11.201 0l.361-.345l.361.344l-.36.345zm-5.581 5.668l.36-.345l.361.345l-.36.345zm0-1.311l.36-.345l.361.344l-.36.345zm-.335-9.619L8.999 9.021l.313.35l2.004-2.006l.346.332l-2.243 2.318l-.73-.644l-1.3 1.324l.301.324l.999-1.004l.73.68l1.258-1.324l.639.644l.346-.368l-.602-.626l1.587-1.656l1.988 2.006l.31-.35l-2.298-2.28l-.675.625zm-1.276 9.277l-.66-.657l.316-.337l.344.337l.976-.994l-.336-.335l.336-.349l.678.684zm3.889 0l.66-.657l-.316-.337l-.344.337l-.977-.994l.337-.335l-.337-.349l-.678.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.143 10.286h-.545l-.312.428h.857zm1.715 0h.545l.312.428h-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.752 10.286v.628l-.725.785l.308.28l-2.295 2.345l-.278-.31l.313-.333l-.34-.339l-.674.672l.979 1.036l2.233-2.193h1.477l2.214 2.193L16 14.014l-.666-.677l-.347.332l.302.345l-.326.31l-2.305-2.344l.336-.281l-.73-.785v-.628zM12.007 12l-.436.429h.857zM12 11.311l-.361.345l.36.344l.362-.344z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlt);
export default __webpack_public_path__ + "static/media/plt.128793dc80b29a52af8ca49c207ca4de.svg";
export { ForwardRef as ReactComponent };